import { Auth } from 'aws-amplify';

export const setHeader = async (axios) => {
  const token = `${(await Auth.currentSession()).getIdToken().getJwtToken()}`;
  axios.defaults.headers.common['Authorization'] = token;
  return axios;
};
